export const alphanumericRegex = /^[a-zA-Z0-9]+$/;
export const alphanumericWithSpacesRegex = /^[a-zA-Z0-9 ]+$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const printableAsciiRegex = /^[\x20-\x7E]+$/;